module.exports = __webpack_public_path__ + "img/thumbnail_RingTailedLemur_f_albino.05479f39.png";